export type PriceProps = {
  price: number;
};
const Price = ({ price }: PriceProps) => {
  return <>{price} €</>;
};

export default Price;
